import HtmlEditor from "../components/HtmlEditor";
import ContentLayout from "../components/layout/ContentLayout";

export default function JournalForm() {
  return (
    <ContentLayout
      header={
        <>
          <HtmlEditor />
        </>
      }
    ></ContentLayout>
  );
}
